import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-bl-terms-conditions',
    templateUrl: './bl-terms-conditions.component.html',
    styleUrls: ['./bl-terms-conditions.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BlTermsConditionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
